// ** Reducers Imports
import NiceModal from "@ebay/nice-modal-react";
import navbar from "./navbar";
import layout from "./layout";
import layoutStatus from "./layoutStatus";
import maintenance from "./maintenance";
import license from "./license";
import sidebar from "./sidebar";
import fonts from '@components/PixelPdf/store'

import dynamicTabs from "@components/PixelTabs/store";
//User Reducers
import loginUser from "@userAuth/Login/store";

import toastify from "./actions/Notify";
import modalDirty from "@components/DynamicModal/store";

import systemTypes from "@src/views/SystemSettings/SystemConfigurations/DropdownLists/store";
import pdfTemplate from '@src/views/SystemSettings/SystemConfigurations/DropdownLists/QuotationDefaultData/PdfTemplates/store'

import coreForm from "@components/Form/store";

import company from "@src/views/SystemSettings/CompanyAccount/store";
import emails from "@personalSector/emails/store";

const nicemodals = NiceModal.reducer;

const rootReducer = {
  nicemodals,
  toastify,
  navbar,
  layout,
  layoutStatus,
  maintenance,
  license,
  sidebar,
  loginUser,
  systemTypes,
  pdfTemplate,
  dynamicTabs,
  coreForm,
  fonts,
  modalDirty,
  company,
  emails,
};

export default rootReducer;
